module.exports = __webpack_public_path__ + "static/media/stmichaelssign.97373c78.jpg";